<div flex="fill" dropdown vbDropdown #mobileMenuDropdown="bs-dropdown">
	<button dropdownToggle id="mainMenu" type="button" class="show-nav btn main-nav-btn btn-mobile theme-accent-bg dropdown-toggle" [ngClass]="{ 'btn-mobile-open bounceInLeft': mobileMenuDropdown.isOpen }" [attr.aria-label]="'UI_MainMenu' | translate" [attr.aria-pressed]="!!mobileMenuDropdown.isOpen" (click)="onToggleClick()">
		<span class="glyphicons theme-accent-txt animated" [ngClass]="mobileMenuDropdown.isOpen ? 'remove_2' : 'show_lines'"></span>
	</button>
	<div *dropdownMenu class="dropdown-menu mobile-menu util-break-word" [ngClass]="{'theme-header-bg' : isNettrixTheme}">
		<div class="container-fluid height-full accent-border theme-accent-border" [ngClass]="{'theme-header' : isNettrixTheme}">
			<ul class="mobile-menu-list" role="menu" aria-labelledby="mainMenu">
				<ng-container *ngIf="!isNettrixTheme">
					<li class="search-cell" *vbAuthorizationKey="'distribution.authenticated'; fallback true" (click)="$event.stopPropagation()">
						<search-header class="theme-Classic-search-header" [headerType]="'Classic'"></search-header>
					</li>
				</ng-container>
				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="'authenticated'" role="none">
					<a [uiSref]="landingState.state" [uiParams]="landingState.params" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-home"></span>
						{{ 'Home' | translate }}
					</a>
				</li>

				<li class="mobile-menu-list-item" [ngClass]="{'isOpen' : showVideoMenu,
								'active': $state.includes(PORTAL_MEDIA_STATE) && !showVideoMenu}" *vbAuthorizationKey="'authenticated'" role="none">
					<button type="button" class="label-text-spacing" (click)="onVideoMenuClick(); $event.stopPropagation()" [ngClass]="{'active' : showVideoMenu}" role="menuitem">
						<span class="vb-icon vb-icon-video"></span>
						{{ 'Media_Videos' | translate }}
						<div flex="1"></div>
						<i class="float-right glyphicons animated menu-item-icon" [ngClass]="{'chevron-right' : !showVideoMenu,
										'chevron-down flipInX' : showVideoMenu}">
						</i>
					</button>

					<my-videos-menu-items *ngIf="showVideoMenu"></my-videos-menu-items>
				</li>

				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="'authenticated'" role="none">
					<a [uiSref]="PORTAL_TEAM_STATE" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-channels"></span>
						{{ 'Teams_Title' | translate }}
					</a>
				</li>

				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="none">
					<a uiSref="portal.scheduledEvents.all" [uiOptions]="{ inherit: false }" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-events"></span>
						{{ 'Events' | translate }}
					</a>
				</li>

				<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizeState="'portal.admin'" role="none">
					<a uiSref="portal.load-admin" [uiParams]="{accountId: accountId}" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
						<span class="vb-icon vb-icon-settings"></span>
						{{ (isAnalystAdmin ? 'Analytics' : 'Admin') | translate }}
					</a>
				</li>

				<ng-container *ngIf="!account.readonlyUserProfile">
					<li class="mobile-menu-list-item" uiSrefActive="active" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="none">
						<a uiSref="portal.userProfile" (click)="subMenu = undefined;" data-toggle="tab" role="menuitem">
							<span class="vb-icon vb-icon-person"></span>
							{{ 'UserProfile_MyProfile' | translate }}
						</a>
					</li>
				</ng-container>

				<ng-container *ngIf="showManageSubscriptions">
					<li *vbAuthorizationKey="['authenticated']" role="none" class="mobile-menu-list-item">
						<a [uiSref]="'portal.manageSubscriptions'" role="menuitem" class="line-height-1">
							<span class="vb-icon vb-icon-subscriptions"></span>
							{{ 'ManageSubscriptions' | translate }}
						</a>
					</li>
				</ng-container>

				<li class="mobile-menu-list-item" [ngClass]="{'isOpen' : showHelpMenu}" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="none">
					<div class="help-menu-container">
						<help-menu-mobile [ngModel]="subMenu" [currentTheme]="theme" (onMobileHelpMenuToggled)="showHelpMenu = $event">
						</help-menu-mobile>
					</div>
				</li>

				<li class="mobile-menu-list-item" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" role="none">
					<a uiSref="logout" role="menuitem">
						<span class="vb-icon vb-icon-exit"></span>
						{{ 'Logout' | translate }}
					</a>
				</li>

				<li class="mobile-menu-list-item" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true" role="none">
					<button type="button" (click)="loginRedirect()" tabindex="0" role="menuitem">
						{{ 'SignIn' | translate }}
					</button>
				</li>
			</ul>
		</div>
	</div>
</div>
